Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaBreakpoint = void 0;
const core_1 = require("@emotion/core");
const styled_system_1 = require("@wheelroom/styled-system");
const merge_ncss_1 = require("../../lib/merge-ncss");
const image_reset_1 = require("../../elements/image-reset");
exports.MediaBreakpoint = (media) => {
    var _a, _b, _c, _d, _e, _f;
    if (!media.small) {
        return null;
    }
    let minWidth = ((_a = media.small.file) === null || _a === void 0 ? void 0 : _a.details.image.width) || 1;
    if (minWidth >= 1024)
        minWidth = 1024;
    const imgAttr = {
        src: ((_b = media.small.file) === null || _b === void 0 ? void 0 : _b.url) + '?w=' + minWidth + '&q=75' || '',
        alt: media.small.description || 'No image description available',
        title: media.small.title || 'No image title available',
    };
    const smallWidth = media.wheel.wrSystemTheme.breakpoints[0];
    const mediumWidth = media.wheel.wrSystemTheme.breakpoints[1];
    const largeWidth = media.wheel.wrSystemTheme.breakpoints[2];
    const extraLargeWidth = media.wheel.wrSystemTheme.breakpoints[3];
    const pictureLabel = { ncss: { label: 'picture' } };
    const imgLabel = { ncss: { label: 'img' } };
    return (core_1.jsx("picture", { css: styled_system_1.styledSystem(media.wheel.wrSystemConfig, media.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([
            pictureLabel,
            image_reset_1.imagePictureReset,
            media.wheel.elementNcss.mediaBreakpoint.picture,
            media.wheel.style.picture,
        ])) },
        extraLargeWidth && media.extraLarge && (core_1.jsx("source", { media: '(min-width:' + extraLargeWidth + ')', srcSet: ((_c = media.extraLarge.file) === null || _c === void 0 ? void 0 : _c.url) + '?q=75' })),
        largeWidth && media.large && (core_1.jsx("source", { media: '(min-width:' + largeWidth + ')', srcSet: ((_d = media.large.file) === null || _d === void 0 ? void 0 : _d.url) + '?q=75' })),
        mediumWidth && media.medium && (core_1.jsx("source", { media: '(min-width:' + mediumWidth + ')', srcSet: ((_e = media.medium.file) === null || _e === void 0 ? void 0 : _e.url) + '?q=75' })),
        smallWidth && media.small && (core_1.jsx("source", { media: '(min-width:' + smallWidth + ')', srcSet: ((_f = media.small.file) === null || _f === void 0 ? void 0 : _f.url) + '?q=75' })),
        core_1.jsx("img", Object.assign({ css: styled_system_1.styledSystem(media.wheel.wrSystemConfig, media.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([
                imgLabel,
                image_reset_1.imageImgReset,
                media.wheel.elementNcss.mediaBreakpoint,
                media.wheel.style,
            ])) }, imgAttr))));
};
//# sourceMappingURL=media-breakpoint.js.map